export default function assertUnreachable(v: never): void {
  // Do nothing
  // console.log(v);
}
